import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import EventIcon from '@material-ui/icons/Event';
import Status from '../../../SkapaMote/Inputs/Status'
import Syfte from '../../../SkapaMote/Inputs/Syfte'
import Kommentar from '../../../SkapaMote/Inputs/Kommentar'
import StartDateTime from '../../../SkapaMote/Inputs/StartDateTime'
import EndDateTime from '../../../SkapaMote/Inputs/EndDateTime'
import ConfirmDatetime from '../../../SkapaMote/Inputs/ConfirmDatetime'
import EventType from '../../../SkapaMote/Inputs/EventType'
import PlatsMote from '../../../SkapaMote/Inputs/PlatsMote'
import InfogaSignatur from '../../../mail/Components/ComposeMail/InfogaSignatur'
import AnsvarigDateRange from '../../../SkapaMote/Inputs/AnsvarigDateRange'
import { isEmpty } from 'lodash';
import { injectIntl } from 'react-intl';

import {isUndefined} from 'lodash'
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
function Mote(props) {
    const classes = useStyles();
    const Eventplaceholder = props.intl.formatMessage({ id: 'Event.Body.placeHolder' });
    console.log(props.Event,"ASD")
    return (
        <>
             <div style={{ paddingTop: '5px' }} className="row">
                    <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <AnsvarigDateRange
                    startDate={props.Event.startDatetime}
                    endDate={props.Event.endDatetime}
                    ansvarig={props.ansvarig}
                    onChangeRange={props.onChangeDateRange}
                    />
                     </div> 
               <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <StartDateTime
                isFrom={1}
                    startDate={props.Event.startDatetime}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    />
                </div>
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <EndDateTime
                isFrom={1}
                    endDate={props.Event.endDatetime}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    UpdateDate={1}
                    />
                </div>
              
                <div 
                className={(parseInt(props.Event.Status) === 1)?"col-12 my-2":"col-12 my-2"}
                style={{ height: 'auto' }}
                >
                    <Status
                    Status={props.Event.Status}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    />
                </div>
            
            {
                (parseInt(props.Event.Status) === 1)?
                    <div className="col-12 my-2"  style={{ height: 'auto' }}>
                        <ConfirmDatetime
                        isFrom={1}
                        ConfirmDate={props.Event.ConfirmDatetime}
                        onchangeHanelEvent={props.onchangeHanelEvent}
                        />
                    </div>
                :""
            }
                <div className="col-6 my-2"  style={{ height: 'auto' }}>
                    <EventType
                    Type={props.Event.Type}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    isFrom={0}
                    />
                </div>
                <div className="col-6 my-2"  style={{ height: 'auto' }}>
                     <PlatsMote
                    Plats={props.Event.Plats}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                   />
                </div>
                {
                    isEmpty(props.signatures)?"":
                    <div className="col-6 my-2"  style={{ height: 'auto' }}>
                    <InfogaSignatur
                    signatures={props.signatures} 
                    handleSelectSignatur={props.onAddSignatur}
                    //handleSelectSignatur={this.handleSelectSignatur.bind(this)}
                    />
                    </div>
                }
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <Syfte
                    HasOutlook={props.HasOutlook}
                    Syfte={props.Event.Syfte}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    />
                </div>
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <Kommentar
                    Meta="Body"
                    placeHolder={isUndefined(props.HasOutlook)?"":parseInt(props.HasOutlook)===1?
                        Eventplaceholder
                        :""}
                    Body={props.Event.Body}
                    onchangeHanelEvent={props.onchangeHanelEvent}
                    />
                </div>
                </div>   
        </>
    );
}

export default injectIntl(Mote);